<template>
    <SweetModal ref="instanceSettingsModal" :title="$t('UI_NAV_SETTINGS_INSTANCE_SETTINGS_MODAL_TITLE')" :blocking="true" :pulse-on-block="false">
        <!-- Instance Rename -->
        <SweetModalTab :title="$t('UI_NAV_SETTINGS_INSTANCE_RENAME')" id="renameTab" icon="">
            <label for="newNameInput">{{ $t('UI_INSTANCE_RENAME_MODAL_TITLE') }}</label>
            <input type="text" v-model="newInstanceName" class="form-control" id="newNameInput">
            <button class="btn btn-primary mt-2 disabled" disabled v-if="newInstanceName === instance.title">{{ $t("UI_NAV_SAVE") }}</button>
            <button class="btn btn-primary mt-2" v-else @click="submitInstanceRename">{{ $t("UI_NAV_SAVE") }}</button>
        </SweetModalTab>

        <!-- Instance Remove Video -->
        <SweetModalTab title="Video" id="videoTab" icon="">
            <div v-if="hasMedia">
                <p>
                    {{ $t('UI_INSTANCE_MEDIA_REMOVE_TEXT') }}
                </p>
                <button class="btn btn-danger" @click="removeMedia">
                    {{ $t('UI_INSTANCE_MEDIA_REMOVE') }}
                </button>
            </div>
            <div v-else>
                <div class="alert alert-primary">
                    {{ $t('UI_MEDIA_NOT_CONNECTED') }}
                </div>
            </div>
        </SweetModalTab>

        <!-- Instance Export -->
        <SweetModalTab title="Export" id="exportTab" icon="">
            <InstanceExport/>
        </SweetModalTab>

        <!-- Instance Delete -->
        <SweetModalTab title="Delete" id="deleteTab" icon="" style="color: red">
            <p v-html="$t('UI_INSTANCE_USER_CONFIRMATION_TEXT', {instanceName: instance.title})"></p>
            <button class="btn btn-danger" @click="deleteInstance">
                {{ $t('UI_INSTANCE_DELETE_MODAL_TITLE') }}
            </button>
        </SweetModalTab>
    </SweetModal>
</template>

<script>
import { SweetModal, SweetModalTab } from 'sweet-modal-vue';
import { RepositoryFactory } from '../../../../repositories/RepositoryFactory';
import InstanceExport from './InstanceExport';

const InstanceRepository = RepositoryFactory.get('instances');
const MediaRepository = RepositoryFactory.get('media');

export default {
  name: 'InstanceSettings',
  data() {
    return {
      newInstanceName: '',
    };
  },
  mounted() {
    this.newInstanceName = this.instance.title;
  },
  components: { InstanceExport, SweetModal, SweetModalTab },
  methods: {
    // Removes the Connected Media from the Instance
    async removeMedia() {
      if (this.instance === null) return false;

      await MediaRepository.remove().then((response) => {
        this.$snotify.info(this.$t('UI_INSTANCE_MEDIA_REMOVED'));

        // Update the Active Instance
        InstanceRepository.refetchActive(false).then(() => {
          this.closeSettingsModal();
        });
      }).catch((error) => {});
    },
    // Rename an Instance
    async submitInstanceRename() {
      if (this.instance === null) return false;

      await InstanceRepository.rename({
        id: this.instance.id,
        title: this.newInstanceName,
      }).then((response) => {
        this.$snotify.info(this.$t('UI_INSTANCE_RENAMED', { title: this.newInstanceName }));

        // Update the Active Instance
        InstanceRepository.refetchActive(false).then(() => {
          this.closeSettingsModal();
        });
      }).catch((error) => {});
    },

    // Delete the Active Instance
    async deleteInstance() {
      if (!this.$store.getters.instanceLoaded) {
        this.$snotify.error(this.$t('UI_INSTANCE_UNABLE_TO_DELETE_NO_INSTANCE_SELECTED'));
        return false;
      }

      await InstanceRepository.delete({ id: this.instance.id })
        .then((response) => {
          this.$snotify.info(this.$t('UI_INSTANCE_DELETED'));
	        this.closeSettingsModal();
	        this.$store.dispatch('setInstanceData', null);
	        this.$router.push({ name: 'home' });
        }).catch((error) => {});
    },
    closeSettingsModal() {
      this.$refs.instanceSettingsModal.close();
    },
  },
  computed: {
    instance() {
      return this.$store.getters.activeInstanceData;
    },
    hasMedia() {
      return this.instance.video !== null;
    },
  },
};
</script>

<style scoped>

</style>
